type SupportWindow = {
	HubSpotConversations?: {
		widget: {
			open: () => void
			load: (options: { widgetOpen: boolean }) => void
		}
	}
	hsConversationsOnReady?: (() => void)[]
	hsConversationsSettings?: Record<string, unknown>
}
let initializing: Promise<void> | undefined

/** Load the native launcher as soon as a standalone reader mounts, without opening chat. */
export async function initializeSupportChat(): Promise<void> {
	const browser = window as unknown as SupportWindow
	if (browser.HubSpotConversations) return
	if (initializing) return initializing
	initializing = new Promise<void>((resolve, reject) => {
		let script = document.getElementById(
			'hs-script-loader'
		) as HTMLScriptElement | null
		const owned = !script
		const finish = (error?: Error) => {
			clearTimeout(timer)
			browser.hsConversationsOnReady = browser.hsConversationsOnReady!.filter(
				(fn) => fn !== ready
			)
			script!.removeEventListener('error', failed)
			if (error) {
				if (owned) script!.remove()
				reject(error)
			} else resolve()
		}
		const ready = () => {
			if (!browser.HubSpotConversations) return
			finish()
		}
		const failed = () => finish(new Error('Support chat could not be loaded.'))
		const timer = window.setTimeout(failed, 20000)
		browser.hsConversationsOnReady = [
			...(browser.hsConversationsOnReady || []),
			ready
		]
		if (!script) {
			browser.hsConversationsSettings = {
				...browser.hsConversationsSettings,
				loadImmediately: true
			}
			script = document.createElement('script')
			script.id = 'hs-script-loader'
			script.async = true
			script.defer = true
			script.src = 'https://js.hs-scripts.com/50591661.js'
			document.body.appendChild(script)
		}
		script.addEventListener('error', failed, { once: true })
	}).finally(() => {
		initializing = undefined
	})
	return initializing
}

let opening: Promise<void> | undefined
/** Get help opens the existing launcher; it never reloads an initialized widget. */
export async function openSupportChat(): Promise<void> {
	if (opening) return opening
	opening = initializeSupportChat()
		.then(() => {
			;(window as unknown as SupportWindow).HubSpotConversations!.widget.open()
		})
		.finally(() => {
			opening = undefined
		})
	return opening
}
